module.exports = "varying highp vec4 _picking_color_pass_;\nvoid main() {\n${out: _picking_fragment_} = _picking_color_pass_;\n}"